module.exports = __webpack_public_path__ + "img/Size=16, Style=regular.097042fb.svg";